import axios from "axios";

export function endStockTake(id) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/stocktake/${id}/end`, {})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
